import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import { sortPrescriptionParameters, PrescriptionValueUtils, isPresent } from "@grandvisionhq/utils";
import { FilesList } from "../../FilesList/FilesList/FilesList.js";
import { PrescriptionType } from "../../types.js";
/* empty css                          */
const lineItemClassName = "line-item-prescription";
const allowedKeys = [
  "power",
  "baseCurve",
  "diameter",
  "cylinder",
  "axis",
  "addition",
  "pupillaryDistance"
];
const Row = ({ prescriptionAttributes, intl }) => {
  const { getLabel } = intl;
  const sortedParams = sortPrescriptionParameters(
    Object.keys(prescriptionAttributes).filter((attribute) => allowedKeys.includes(attribute))
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, sortedParams.map((key) => {
    const value = PrescriptionValueUtils.formatPrescriptionValue(
      key,
      prescriptionAttributes[key]
    );
    if (!isPresent(value)) return null;
    return /* @__PURE__ */ React.createElement("span", { className: `${lineItemClassName}__item`, key }, getLabel(`cart.lineItem.glasses.prescription.${key}`), ": ", value);
  }));
};
const NewPrescriptionDetails = ({
  rightTitle,
  leftTitle,
  intl,
  rightLens,
  leftLens
}) => /* @__PURE__ */ React.createElement("div", { className: `${lineItemClassName}__prescription-group` }, rightLens && /* @__PURE__ */ React.createElement("div", { className: `${lineItemClassName}__group` }, /* @__PURE__ */ React.createElement("span", { className: `${lineItemClassName}__item ${lineItemClassName}__title` }, rightTitle), /* @__PURE__ */ React.createElement(Row, { prescriptionAttributes: rightLens, intl })), leftLens && /* @__PURE__ */ React.createElement("div", { className: `${lineItemClassName}__group` }, /* @__PURE__ */ React.createElement("span", { className: `${lineItemClassName}__item ${lineItemClassName}__title` }, leftTitle), /* @__PURE__ */ React.createElement(Row, { prescriptionAttributes: leftLens, intl })));
const PrescriptionMessage = ({ title, message }) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: `${lineItemClassName}__title` }, title), message);
const Body = ({ prescription, intl }) => {
  const { getLabel } = intl;
  switch (prescription.type) {
    case PrescriptionType.PRESCRIPTION_FILE:
      return /* @__PURE__ */ React.createElement(FilesList, { items: [prescription.pupillaryDistanceFile, prescription.prescriptionFile] });
    case PrescriptionType.NEW_PRESCRIPTION:
      const { rightLens, leftLens } = prescription;
      return /* @__PURE__ */ React.createElement(
        NewPrescriptionDetails,
        {
          rightTitle: `${getLabel("common.right")}: `,
          leftTitle: `${getLabel("common.left")}: `,
          rightLens,
          leftLens,
          intl
        }
      );
    case PrescriptionType.EMAIL_PRESCRIPTION:
      return /* @__PURE__ */ React.createElement(
        PrescriptionMessage,
        {
          title: `${getLabel("cart.lineItem.glasses.emailPrescription.title")}: `,
          message: `${getLabel("cart.lineItem.glasses.emailPrescription.message")}`
        }
      );
    case PrescriptionType.EXISTING_CUSTOMER:
      return /* @__PURE__ */ React.createElement(
        PrescriptionMessage,
        {
          title: `${getLabel("cart.lineItem.glasses.noPrescription.title")}: `,
          message: `${getLabel("cart.lineItem.glasses.noPrescription.message")}`
        }
      );
  }
};
const LineItemPrescription = ({ prescription, className, ...rest }) => {
  const intl = useIntl();
  const { getLabel } = intl;
  return /* @__PURE__ */ React.createElement("div", { className: classnames([lineItemClassName, className]), "data-t": rest["data-t"] }, /* @__PURE__ */ React.createElement("p", { className: `${lineItemClassName}__headline` }, getLabel("account.order.labels.prescriptionDetails")), /* @__PURE__ */ React.createElement(Body, { prescription, intl }));
};
export {
  LineItemPrescription as default
};
//# sourceMappingURL=LineItemPrescription.js.map
